import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';

interface ErrorFallbackProps {
  error?: Error;
  resetErrorBoundary?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <Container className="mt-5">
      <Alert variant="danger">
        <Alert.Heading>Something went wrong</Alert.Heading>
        <p>
          {error?.message || 'An unexpected error occurred. Please try again later.'}
        </p>
        {resetErrorBoundary && (
          <div className="d-flex justify-content-end">
            <Button onClick={resetErrorBoundary} variant="outline-danger">
              Try again
            </Button>
          </div>
        )}
      </Alert>
    </Container>
  );
};

export default ErrorFallback; 